export default __webpack_public_path__ + "static/media/hht2_ep07_book_wp_02.961abb00.jpg";